import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageUtils } from '../../../utils/storage-utils';
import { RestService } from '../../../utils/rest-service';
import { JsonContainer } from '../../../utils/json-container';
import { DocumentFile } from './document-file';
import { DocumentFileSearch } from './document-file-search';


@Injectable()
export class DocumentFileService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'documentFile', storageUtils);
    }

    load(id: string, callback: (result: JsonContainer, doc: DocumentFile) => void) {
        this.executeGet('load/' + id, callback)
    }

    save(doc: DocumentFile, callback: (result: JsonContainer) => void) {
        this.executePut('save', doc, callback)
    }

    saveFile(doc: DocumentFile, callback: (result: JsonContainer) => void) {
        this.executePut('saveFile', doc, callback)
    }

    saveDefaultFile(doc: Array<DocumentFile>, callback: (result: JsonContainer) => void) {
        this.executePut('saveDefault', doc, callback)
    }

    search(search: DocumentFileSearch, callback: (result: JsonContainer, data: any) => void) {
        this.executePost('search', search, callback)
    }

    searchMensalCheckList(search: DocumentFileSearch, callback: (result: JsonContainer, data: any) => void) {
        this.executePost('searchMensalCheckList', search, callback)
    }

    searchDefault(search: DocumentFileSearch, callback: (result: JsonContainer, data: any) => void) {
        this.executePost('searchDefault', search, callback)
    }

    searchCheckList(search: DocumentFileSearch, callback: (result: JsonContainer, data: any) => void) {
        this.executePost('searchCheckList', search, callback)
    }

    delete(id: string, callback: (result: JsonContainer, doc: DocumentFile) => void) {
        this.executeDelete('delete/' + id, callback)
    }
}
